(function () {
  /* ── Build DOM ─────────────────────────────────────── */
  var backdrop = document.createElement('div');
  backdrop.className = 'upi-offer-backdrop';
  document.body.appendChild(backdrop);

  var globalPopup = document.createElement('div');
  globalPopup.className = 'upi-offer-popup--global';
  globalPopup.style.display = 'none';   // start hidden
  document.body.appendChild(globalPopup);

  var currentBtn = null;
  var MOBILE_BP = 768;

  /* ── Helpers ───────────────────────────────────────── */
  function isMobile() { return window.innerWidth < MOBILE_BP; }

  function positionDesktop(btn) {
    var rect   = btn.getBoundingClientRect();
    var popW   = globalPopup.offsetWidth  || 200;
    var popH   = globalPopup.offsetHeight || 130;
    var margin = 8;

    // Centre horizontally over button, clamp to viewport
    var left = rect.left + rect.width / 2 - popW / 2;
    left = Math.max(margin, Math.min(left, window.innerWidth - popW - margin));

    // Below by default; flip above if not enough space
    var top = (window.innerHeight - rect.bottom >= popH + margin)
      ? rect.bottom + 6
      : rect.top - popH - 6;

    globalPopup.style.top       = top  + 'px';
    globalPopup.style.left      = left + 'px';
    globalPopup.style.transform = '';   // no translate centering on desktop
  }

  /* ── Open ──────────────────────────────────────────── */
  function openPopup(btn) {
    var source = document.getElementById(btn.getAttribute('data-offer-toggle'));
    if (!source) return;

    // Load content
    globalPopup.innerHTML = source.innerHTML;

    // Reset state — remove open class so base (opacity:0) state is active
    globalPopup.classList.remove('upi-offer-popup--open', 'upi-offer-popup--mobile');

    if (isMobile()) {
      /* --- Mobile: centred modal --- */
      globalPopup.classList.add('upi-offer-popup--mobile');
      globalPopup.style.top       = '50%';
      globalPopup.style.left      = '50%';
      globalPopup.style.transform = '';  // CSS class handles translate
      backdrop.classList.add('upi-offer-backdrop--visible');
    } else {
      /* --- Desktop: position near button --- */
      // Temporarily off-screen so we can measure
      globalPopup.style.top  = '-9999px';
      globalPopup.style.left = '-9999px';
      backdrop.classList.remove('upi-offer-backdrop--visible');
    }

    // Make block (still opacity:0 from CSS)
    globalPopup.style.display = 'block';

    // Measure + position (must be after display:block)
    if (!isMobile()) positionDesktop(btn);

    // Trigger in-animation on next frame
    requestAnimationFrame(function () {
      globalPopup.classList.add('upi-offer-popup--open');
    });

    currentBtn = btn;
  }

  /* ── Close (instant — no out animation) ────────────── */
  function closePopup() {
    globalPopup.style.display = 'none';
    globalPopup.classList.remove('upi-offer-popup--open', 'upi-offer-popup--mobile');
    backdrop.classList.remove('upi-offer-backdrop--visible');
    currentBtn = null;
  }

  /* ── Click handler (capture = intercept card link) ─── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-offer-toggle]');

    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      // Toggle: click again to close
      if (currentBtn === btn && globalPopup.style.display !== 'none') {
        closePopup();
      } else {
        openPopup(btn);
      }
      return;
    }

    // Click outside closes
    if (!globalPopup.contains(e.target)) closePopup();
  }, true);  // capture phase

  /* ── Keyboard + scroll + resize ────────────────────── */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePopup();
  });

  window.addEventListener('scroll', function () {
    if (currentBtn && !isMobile() && globalPopup.style.display !== 'none') {
      positionDesktop(currentBtn);
    }
  }, { passive: true });

  window.addEventListener('resize', function () {
    if (!currentBtn || globalPopup.style.display === 'none') return;
    if (isMobile()) {
      if (!globalPopup.classList.contains('upi-offer-popup--mobile')) {
        globalPopup.classList.add('upi-offer-popup--mobile');
        globalPopup.style.top  = '50%';
        globalPopup.style.left = '50%';
        backdrop.classList.add('upi-offer-backdrop--visible');
      }
    } else {
      globalPopup.classList.remove('upi-offer-popup--mobile');
      backdrop.classList.remove('upi-offer-backdrop--visible');
      positionDesktop(currentBtn);
    }
  });
})();
